const API_ENDPOINTS = {
  LOGIN: '/accounts/login',
  LOGIN_INFO: '/accounts/login_info',
  LOGOUT: '/accounts/logout',
  SEND_OTP: '/accounts/SendOtp',
  VERIFY_OTP: '/accounts/VerifyOtp',
  // Assisted-journey 2FA: OTP is issued by /accounts/login itself when the payload
  // carries `platform_name`, then verified here. Encrypted `request_data` body and
  // the field is `otp_reference_id`, not `reference_id`.
  VERIFY_OTP_ASSIST: '/accounts/verify-otp',
  FETCH_USER_DATA: '/accounts/fetchuserdata',
  // Quotations Page
  ADD_ONS: '/policy/addons',
  ADDITIONAL_COVERS: '/policy/additionalcovers',
  MOTOR_QUOTATIONS: '/policy/quotation/v2',
  MOTOR_SALES_BANK: '/policy/policy-listing',
  MOTOR_SALES_DOWNLOAD: '/policy/policy-listing/download',
  PLAN_DETAILS: '/policy/details',
  MOTOR_STAFF_ID: '/policy/staff-discount/check',
  AUTH: '/accounts/authtoken',
  MANUFACTURERS: '/dropdown/manufacturer',
  MODELS: '/dropdown/model',
  VARIANTS: '/dropdown/variant',
  INSURERS: '/insurer/listing',
  INSURERS_COMMERCIAL: '/policy/insurer-listing',
  RTO: '/dropdown/rto',
  CPA_CHECK: '/policy/cpa',
  VAHAN_CHECK: '/policy/fetch-vahan-details',
  OFFLINE_UPLOAD: '/policy/offline-upload',
  PINCODE_CMS: '/autofill/pincode',
  OCCUPATIONS: '/mapping/occupations',
  RELATIONSHIPS: '/mapping/relationships',
  MOTOR_PROPOSAL: '/policy/proposal',
  CKYC_VALIDATE: '/policy/CkycValidateInsurer',
  CKYC_NUMBER: '/policy/GetCkycNumber',
  IMAGE_RC_OCR: '/policy/prefill-data-rc',
  IMAGE_POLICY_OCR: '/policy/prefill-data-policy',
  PAYMENT_CHECK: '/policy/paymentcheck',
  HYPOTHECATION: '/policy/miscellaneous',
  SELECT_PAYMENT_CHANNEL: '/policy/select-payment-channel',

  // health

  HEALTH_QUOTATION: '/common/quotation',
  HEATH_ADDONS: '/common/list-riders',
  HEALTH_PINCODE: '/common/pincode',
  HEALTH_SPECIFIC_CITY_PINCODE: '/common/insurer-pincode-api',
  HEALTH_SUMINSURED_GENRIC: '/common/list-suminsured',
  HEALTH_INSURER_LISTING: '/insurer/list-insurer',
  HEALTH_INSURANCE_LISTING: '/insurer/list-insurer-plans',
  HEALTH_CKYC_VALIDATE: '/common/validate-ckyc-insurer',
  HEALTH_CKYC_SEND_OTP: '/common/ckyc-send-otp',
  HEALTH_CKYC_VALIDATE_OTP: '/common/ckyc-validate-otp',
  HEALTH_CKYC_NUMBER: '/common/check-ckyc',
  HEALTH_SALES_REPORT: '/operations/healthsold',

  HEALTH_QUES: '/common/question',
  HEALTH_LIST_MISCELLANEOUS: '/common/list-miscellaneous',
  HEALTH_BENEFITS: '/insurer/list-benifits',
  HEALTH_PROPOSAL: '/common/proposal',
  HEALTH_SALES_BANK: '/common/sales_report',
  HEALTH_COMPARE_FIELDS: '/common/list-policy-compare-fields',
  HEALTH_COMPARE_LISTING: '/common/policy-compare',
  HEALTH_CONSENT: '/common/health-constent-generate',
  HEALTH_CONSENT_RESEND: '/common/health-constent-resend',

  HEALTH_CONSENT_SUBMIT_FORM: '/common/health-constent-submit',
  CONSENT_CHECK: '/common/health-constent-check',
  BMI_CHECK: '/common/check-bmi',
  HEALTH_PAYMENT_CHECK: '/health/payment/check',
  HEALTH_DMS_DATA_PUSH: '/common/dms-data-push',
  CASHLESS_HOSPITALS: '/insurer/list-cash-less-hospitals',
  HEALTH_CREATE_CART: '/cart/api/create-cart',
  HEALTH_UPDATE_CART: '/cart/api/update-cart/',

  HEALTH_SEND_EMAIL: '/v1/send_email/',
  HEALTH_SEND_SMS: '/v1/send_sms/',
  HEALTH_SALES_REPORT_DOWNLOAD: '/operations/download-csv/',

  GET_MOTOR_CUSTOMER_CONSENT_FORM_LINK: '/policy/motor-constent',
  SUBMIT_MOTOR_CUSTOMER_CONSENT_FORM: '/policy/motor-constent/submit',

  SUBMIT_SP_CONSENT_FORM: '/policy/sp-consent/submit',

  CONSENT_UPLOAD: '/policy/consent-upload',
  SP_TAGGING_VERIFY_OTP: '/accounts/validate-otp/v2',
  OTP_CONSENT: '/common/send-otp',
  OTP_VALIDATE_CONSENT: '/common/validate-otp',
  GET_DEDUCTIBLE_LIST: '/common/list-deductibles',

  // ckyc

  // group
  GROUP_HEALTH_SALES_REPORT: '/operations/groupsppsold',

  // My Leads
  SAVE_LEAD: '/leads/v1/save-lead',
  LEAD_LISTING: '/leads/v2/my-leads',
  LEAD_REASSIGN: '/leads/v2/reassign',
  CLOSE_LEAD: '/leads/v1/my-leads/close',
  DOWNLOAD_REPORT: '/leads/v1/my-leads/report/download',
  LEADS_DOWNLOAD_REPORT: '/lms/v1/leads/report/download',

  GET_SP_CONSENT_FORM_LINK: '/policy/sp-consent',
  SP_TAGGING_SEND_OTP: '/accounts/send-otp/v2',

  // Common
  CUSTOMER_SEARCH: '/equitasacl/equitas/search',
  CUSTOMER_DETAILS: '/equitasacl/equitas/v3/cust-details',
  SP_LISTING: '/accounts/fetchspuserdatalist',
  IMAGE_RC_OCR_BANK: '/ocr/rcocr',
  IMAGE_POLICY_OCR_BANK: '/ocr/pdfocr',
  MOTOR_SALES_SUMMARY_BANK: '/policy/motor/summary',
  SUPPORT_LISTING: '/accounts/listing_status',
  ISSUE_TYPE_DROPDOWN: '/accounts/issue_list',
  SUPPORT_CREATION: '/accounts/new_request_api',
  SEND_EMAIL: '/equitasacl/common/send-mail',
  SEND_SMS: '/equitasacl/common/send-sms',
  SEND_OTP_NEW: '/policy/send_otp',
  VALIDATE_OTP_NEW: '/policy/validate_otp',
  GET_REPORT_AND_DASHBOARD: '/pas/getreportsandashboard',
  GET_ALL_BRANCHES: '/accounts/get_all_branchdata',
  GET_BRANCH_DASHBOARD: '/pas/get_branch_dashboard',
  GET_SOL_ID_LISTING: '/accounts/list_priority_branches',

  // BOB
  BOB: {
    TRAVEL: {
      GET_COUNTRIES_LIST: '/common/countries/',
      CREATE_TRAVEL_CUSTOMER: '/common/create_customer/',
      GET_ADDONS: '/common/addons/',
      GET_SUM_INSURRED: '/common/SumInsuredList/',
      CREATE_QUOTE: '/travel/create-quote/',
      GET_CKYC_OPTIONS: '/travel/CkycValidateInsurer',
      POST_CKYC_NUMBER: '/travel/GetCkycNumber',
      GET_TRAVEL_CUSTOMER_CONSENT: '/common/consent',
      GET_TRAVEL_PAYMENT_STATUS: '/travel/payment-status',
      POST_PAYMENT_CONSENT: '/travel/payment',
      CREATE_PROPOSAL: '/travel/proposal/',
      GET_POLICY_DETAILS: '/common/policy_details/',
      MEDICAL_QUESTIONS: '/questions',
    },
    // accounts
    BOB_OTP_LOGIN: '/accounts/otp-login-agent/',
    BOB_OTP_VERIFY: '/accounts/otp-login-agent/',
    GET_SP_USER_DETAILS: '/accounts/fetchspuserdatalist',

    // customer
    BOB_CBS_CUSTOMER: '/customer/getCBSCustomer',
    GET_CUSTOMER_CKYC: '/customer/get-customer-ckyc',
    BOB_PINCODE: '/customer/pincode-detail',
    CREATE_EKYC_CUSTOMER: '/customer/ekyc-customer-create',
    IMAGE_OCR_BOB: '/customer/get-ocr-data',
    DOC_UPLOAD: '/customer/customer-document',
    CREATE_CUSTOMER: '/customer/store-cbs-customer',
    UPDATE_CUSTOMER_DETAILS: '/customer/update-details',

    // product
    BOB_EKYC_CUSTOMER: '/product/life/ekyc-customer/fetch-detail',
    GET_QUESTIONS_LIST: '/product/life/get-questions-list',
    QUOTE_FORM_PLAN: '/product/life/get-questions-list',
    GET_SP_DATA: '/product/life/get-sp-data',
    RECOMMENDED_PLANS: '/product/life/quote',
    BOB_RELATIONSHIPS: '/product/life/get-relationships',
    BOB_LIST_FORM: '/product/life/get-choices',
    GET_QUOTES: '/product/life/plan-quote',
    GET_CREATE_PROPOSAL: '/product/life/create-proposal',
    SUBMIT_EXISTING_INSURANCE_DETAILS: '/product/life/submitExistingInsuranceDetails',
    SUBMIT_NOMINEE: '/product/life/proposal/submit-nominee',
    SUBMIT_FATCA_DETAILS: '/product/life/submitFatcaDetails',
    SUBMIT_ECS_DETAILS: '/product/life/save-ecs-data',
    SUBMIT_EIA_DETAILS: '/product/life/save-eia-data',
    SUBMIT_HEALTH_DETAILS: '/product/life/submit-health-details',
    SEND_PROPOSAL_OTP: '/product/life/send-proposal-otp',
    PROPOSAL_SUBMISSION_TO_INSURER: '/product/life/proposal-submission-to-insurer',
    GET_SEND_CONSENTLINK: '/product/life/get-send-consentlink/',
    GET_DOC_LIST: '/product/life/doc_list',
    SAVE_SUITABILITY: '/product/life/save-suitability',
    CHECK_CONSENT_STATUS: '/product/life/proposal-status-within-journey',
    GET_CONSENT_FORM_LINK: '/product/life/get-send-consentlink/',
    SUBMIT_ACR_DETAILS: '/product/life/proposal/submit-acr-details',
    CHECK_SP_STATUS: '/product/life/SP-consent-status',
    SEND_OTP_SP_CONSENT: '/product/life/sp_consent_sendotp',
    VERIFY_OTP: '/product/life/verify-otp',
    POLICY_SUBMISSION: '/product/life/policy-submission',
    DECLARATION_DETAILS: '/product/life/declaration-details',
    DECLARATION_SEND_OTP: '/product/life/declaration-send-otp',
    DECLARATION_VERIFY_OTP: '/product/life/declaration-verify-otp',

    // person disability consent (IndiaFirst only)
    DISABILITY_CONSENT_SEND_LINK: '/product/life/disability-consent-send-link',
    DISABILITY_CONSENT_STATUS: '/product/life/disability-consent-status',

    GET_GROUP_PLAN_INFO: '/product/policy_details/',
    GET_GROUP_POLICY_PDF: '/product/policy-pdf/',

    // initial customer consent
    GET_INITIAL_CUSTOMER_CONSENT_LINK: '/product/life/get-send-consentlink/',
    GET_STATUS_INITIAL_CUSTOMER_CONSENT: '/product/life/consent-approval-status',

    // proposal payment
    GET_PAYMENT_LINK: '/product/life/proposal/get-payment-link',
    GET_BOB_PAYMENT_LINK: '/product/life/fetch-payment-url-from-bob-pg',
    AUTO_DEBIT: '/product/life/payment-auto-debit-mode',
    PAYMENT_STATUS: '/product/life/payment-check-status',

    // master
    GET_CHOICES: '/customer-360/get-choices',
    GET_CHOICES_MASTER: '/master/get-choices',
    VALIDATE_PAN: '/master/validate-pan',
    GET_PINCODE_LIST: '/master/pincode_list/',
    GET_RIDER: '/master/rider/',
    GET_MASTER_QUESTIONS_LIST: '/master/get_question_list/',
    GET_BRANCH_DETAILS_LIST: '/master/branch_details_list',
    GET_PLAN_DATA: '/master/get-plan-data',

    // lms
    LMS_CREATE_LEAD: '/lms/v1/create-lead',
    LMS_UPDATE_LEAD: '/lms/v1/update-lead',
    LMS_GET_LEAD_LISTING: '/lms/v1/leads/dashboard',
    LMS_GET_LEAD_ANALYTICS: '/lms/v1/leads/analytics',
    LEAD_COUNT: '/lms/v1/leadcount',

    // operations
    GET_SALES_REPORT: '/operations/lifesold/',
    GET_BGR_SALES_REPORT: '/operations/bgrsold/',
    GET_FIRE_SALES_REPORT: '/operations/firesold/',
    EXPORT_CSV: '/pas/api/create-csv-task/',

    // customer-360
    GET_POLICY_LISTING: '/customer-360/policy-listing',
    GET_LIFE_ENDORSE_FINANCIAL: '/customer-360/life-endorsement-financial',
    FMS_FILE_UPLOAD: '/manager/files/receiver/',
    RAISE_CLAIM: '/customer-360/raise-claim',
    GET_TICKET_LISTING: '/customer-360/ticket-listing',
    POST_CANCELLATION: '/customer-360/raise-cancellation',
    POST_GRIEVANCE: '/customer-360/raise-grievance',
    POST_SURRENDER: '/customer-360/raise-surrender',
    RAISE_ENDORSEMENT: '/customer-360/raise-endorsement',
    GET_POLICY_INFORMATION: '/policy/details',
    GET_HEALTH_POLICY_INFORMATION: '/insurer/compare-insurer-plans',
    GET_LIFE_POLICY_INFORMATION: '/master/get-plan-details',
    MOTOR_GET_PROPOSAL_DETAILS: '/policy/get-proposal-request',
    GET_HEALTH_ENDORSE_FINANCIAL: '/insurer/insurer-and-insurance-details-for-endorsement',
    GET_ENDORSE_COMMON_PROPOSAL_DETAILS: '/common/proposal-details-for-endorsement',
    GET_DOCUMENTS_FOR_FILE_UPLOAD: '/customer-360/list-document-upload',
    ALLOWED_SERVICES: '/customer-360/allowed-operations',
    SEND_REMINDER: '/customer-360/send-reminder',
    NON_LIFE_SEND_REMINDER: '/customer-360/send-renewal-reminder',
    GET_RENEWAL_DATA: '/customer-360/get-renewal-data',
    GET_RENEWAL_DATA_MOTOR: '/customer-360/get-motor-renewal-data',
    GET_RENEWAL_DATA_HEALTH: '/customer-360/get-health-renewal-data',
    CHECK_RENEWAL_LIFE_CONSENT_STATUS: '/customer-360/renewal-consent-status',
    SEND_CONSENT_LINK: '/customer-360/send-consent-link',
    STANDALONE_RENEWAL_PRODUCTS: '/customer-360/standalone-renewal/products',
    STANDALONE_RENEWAL_SEARCH: '/customer-360/standalone-renewal/search',
    STANDALONE_RENEWAL_CONSENT: '/customer-360/standalone-renewal/send-consent-link',
    STANDALONE_RENEWAL_SP_CONSENT: '/customer-360/standalone-renewal/send-sp-consent-link',
    // Customer 360 renewal (existing policy) — keyed by pas_id instead of search_id
    RENEWAL_SP_CONSENT_SEND: '/customer-360/renewal/send-sp-consent-link',
    // Agent-side poll; the SP flow has no tran_id, so renewal-consent-status does not apply
    STANDALONE_RENEWAL_SP_STATUS: '/customer-360/standalone-renewal/sp-consent-status',
    RENEWAL_POLICY_STATUS: '/customer-360/renewal-policy-status',
    // CONSENT APIs
    CONSENT_CREATION: '/customer-360/consent/create/',
    GET_CONSENT: '/customer-360/consent/get',
    SEND_OTP: '/customer-360/send-otp',
    VERIFY_OTP_FOR_ENDORSEMENT: '/customer-360/verify-otp',
    SAVE_CONSENT: '/customer-360/consent/save/',

    // BGR
    BGR_QUOTATIONS: '/bgr/quote/',
    BGR_PLAN_QUOTE: '/bgr/plan_quote/',
    GET_BGR_CUSTOMER_CONSENT_LINK: '/master/get-send-consent',
    GET_BGR_CUSTOMER_CONSENT_STATUS: '/master/customer-consent-status',
    DIRECT_DEBIT_MAKE_PAYMENT_BGR: '/bgr/make-payment/',
    DOWNLOAD_POLICY: '/bgr/download-policy/',
    QUOTE_LISTING: '/bgr/quote/polling/',
    BGR_POLICY_STATUS: '/bgr/policy-status/',
    BGR_VERIFY_CKYC: '/bgr/ckyc/verify/',
    BGR_OVD_CKYC: '/bgr/ckyc/ovd/',
    BGR_CKYC_STATUS: '/bgr/ckyc/status/',
    BGR_CKYC_OTP_VERIFY: '/bgr/ckyc/otp/verify/',
    BGR_LIST_BENEFITS: '/master/list-benifits',
    BGR_COMPAIRE_PLANS: '/master/compare-insurer-plans',
    SELECT_PAYMENT_CHANNEL_BGR: '/common/select-payment-channel',

    GET_MOTOR_SALES: '/operations/motorsold/',
    HEALTH_GET_PROPOSAL_DETAILS: '/common/proposal-details-for-endorsement',

    // FIRE
    GET_PROPERTY_QUESTIONS: '/master/get_question_list/',
    GET_OCCUPANCY_LIST: '/common/occupancies',
    FIRE_VERIFY_CKYC: '/fire/ckyc/verify/',
    FIRE_OVD_CKYC: '/fire/ckyc/ovd/',
    FIRE_CKYC_STATUS: '/fire/ckyc/status/',
    FIRE_CKYC_OTP_VERIFY: '/fire/ckyc/otp/verify/',
    GET_FIRE_TRACE_ID: '/fire/quote/',
    GET_FIRE_QUOTES: '/fire/quote/polling/',
    DIRECT_DEBIT_MAKE_PAYMENT_FIRE: '/fire/make-payment/',
    FIRE_POLICY_STATUS: '/fire/policy-status/',
    FIRE_PLAN_QUOTE: '/fire/plan_quote/',
    FIRE_DOWNLOAD_POLICY: '/fire/download-policy/',
    // group
    CREATE_QUOTE_ID_FD: '/product/create-quote-id/',
    CREATE_CUSTOMER_FD: '/group_fd/quote-details/',
    CREATE_CELERY_TASK_FD: '/group_fd/tasks/quote/',
    GET_FD_QUOTATIONS: '/group_fd/tasks/quote/',
    CREATE_PROPOSALS: '/group_fd/proposal/',
    GET_RELATIONSHIP: '/product/relationships/',
    GET_OCCUPATIONS: '/product/occupations/',
    GET_GENDERS: '/product/genders/',
    GET_SALUTATIONS: '/product/salutations/',
    GET_PAYMENT_STATUS: '/product/payment-status',
    CREATE_CONSENT: '/product/consent',
    GROUP_HEALTH_SUMINSURED_GENRIC: '/product/plan-suminsured/',

    // GROUP HEALTH CONSENT ENDPOINTS
    CREATE_CONSENT_GROUP: '/product/generate-customer-consent-url',
    UPDATE_CONSENT_GROUP: '/product/resend-customer-consent-url',
    CUSTOMER_CONSENT_STATUS: '/product/customer-consent-status-check-polling',
    PAYMENT_CHECK_GROUP: '/product/payment/check/',

    GET_INSURANCE_DATA: '/product/insurances/',

    //  GROUP SPP
    CREATE_CUSTOMER_GROUPSPP: '/group_spp/quote-details/',
    CREATE_CELERY_TASK_GROUPSPP: '/group_spp/tasks/quote/',
    GET_GROUPSPP_QUOTATIONS_SPP: '/group_spp/tasks/quote/',
    CREATE_PROPOSALS_GROUPSPP: '/group_spp/proposal/',
    GROUP_SPP_CHECK_DATA_PUSH: '/group_spp/data-push/',
    GET_INSURER_LISTING_SPP: '/group_spp/spp-listing/',
    GET_APPLICATION_STATUS_SPP: '/group_spp/application-status/',

    //  GROUP SB
    CREATE_CUSTOMER_GROUPSB: '/group_sb/quote-details/',
    CREATE_CELERY_TASK_GROUPSB: '/group_sb/tasks/quote/',
    GET_GROUPSPP_QUOTATIONS_SB: '/group_sb/tasks/quote/',
    CREATE_PROPOSALS_GROUPSB: '/group_sb/proposal/',
    GROUP_SB_CHECK_DATA_PUSH: '/group_sb/data-push/',
    GET_INSURER_LISTING_SB: '/group_sb/sb-listing/',
    GET_APPLICATION_STATUS_SB: '/group_sb/application-status/',

    MEDICAL_QUESTIONS: '/product/questions',
  },
}

export { API_ENDPOINTS }
